import {CONDITION_OPERATORS} from './condition-operators.model';
import {OPERATOR_COMPARAISON} from './operator.comparaison.model';

/**
 * Comparaisons offertes par ce qui ne s'ordonne pas : le statut d'un indicateur, le choix d'une
 * question à choix, le genre ou la langue d'un répondant.
 *
 * « Après le détracteur » ne veut rien dire — seule l'égalité a un sens sur ces réponses-là. C'est
 * le cas de tout ce que l'éditeur sait comparer aujourd'hui, sauf l'échelle d'évaluation.
 *
 * Dérivées de la liste de référence plutôt que réécrites : les deux premières y sont précisément
 * l'égalité et son contraire, et l'ordre d'affichage reste ainsi le même partout.
 */
export const EQUALITY_CONDITION_OPERATORS: OPERATOR_COMPARAISON[] = CONDITION_OPERATORS.slice(0, 2);
